var global = require('./$.global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


/*****************
 ** WEBPACK FOOTER
 ** /~/redux-api-middleware/~/core-js/library/modules/$.shared.js
 ** module id = 685
 ** module chunks = 0
 **/